export type NextRequestSignal = () => AbortSignal;

export default function createLatestRequestSignal(): NextRequestSignal {
  let controller: AbortController | null = null;

  return () => {
    controller?.abort();
    controller = new AbortController();

    return controller.signal;
  };
}
